(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initInfinite(root) {
    if (!root || root.dataset.lmpInfiniteBound === 'true') return;
    root.dataset.lmpInfiniteBound = 'true';

    var grid = root.querySelector('[data-lmp-products-grid]');
    var button = root.querySelector('[data-lmp-load-more]');
    var panel = root.querySelector('[data-lmp-infinite-panel]');
    var sentinel = root.querySelector('[data-lmp-infinite-sentinel]');
    if (!grid) return;

    // Promotional tiles are content, never products. Recalculate after infinite-scroll batches.
    var promoConfigNode = grid.querySelector('[data-los-promo-config]');
    var promoConfig = null;
    try { if (promoConfigNode) promoConfig = JSON.parse(promoConfigNode.textContent); } catch (error) { promoConfig = null; }
    function renderPromos() {
      if (!promoConfig || (promoConfig.scope !== 'all' && ['therapiespiegel-zur-spiegeltherapie','aluminium-spiegel'].indexOf(promoConfig.collection) === -1)) return;
      grid.querySelectorAll('[data-los-inline-promo]').forEach(function (node) { node.remove(); });
      var demo = grid.querySelector('[data-los-inline-promo-demo]');
      if (demo) demo.remove();
      var products = Array.prototype.slice.call(grid.querySelectorAll('[data-lmp-product-card]'));
      var interval = Math.max(4, Number(promoConfig.interval) || 12);
      var target = promoConfig.url || '/collections/therapiespiegel-zur-spiegeltherapie';
      if (!target.startsWith('/') || target.startsWith('//')) target = '/collections/therapiespiegel-zur-spiegeltherapie';
      var positions = [];
      if (products.length > 0 && products.length < interval) positions.push(products.length);
      else for (var step = interval; step <= products.length; step += interval) positions.push(step);
      positions.forEach(function (i) {
        var card = document.createElement('article');
        card.className = 'los-inline-promo';
        card.setAttribute('data-los-inline-promo', '');
        var media = document.createElement('div');
        media.className = 'los-inline-promo__media';
        if (promoConfig.image && /^https:\/\//.test(promoConfig.image)) {
          var img = document.createElement('img');
          img.src = promoConfig.image;
          img.alt = '';
          img.loading = 'lazy';
          media.appendChild(img);
        } else {
          var mark = document.createElement('span');
          mark.className = 'los-inline-promo__mark';
          mark.textContent = '✦';
          media.appendChild(mark);
        }
        var body = document.createElement('div');
        body.className = 'los-inline-promo__content';
        var eyebrow = document.createElement('span');
        eyebrow.className = 'los-inline-promo__eyebrow';
        eyebrow.textContent = 'EMPFEHLUNG';
        var title = document.createElement('h3');
        title.textContent = promoConfig.title || 'Mehr entdecken';
        var description = document.createElement('p');
        description.textContent = promoConfig.description || '';
        var link = document.createElement('a');
        link.className = 'los-inline-promo__link';
        link.href = target;
        link.textContent = promoConfig.label || 'Mehr entdecken';
        body.append(eyebrow, title, description, link);
        card.append(media, body);
        products[i - 1].insertAdjacentElement('afterend', card);
      });
    }
    renderPromos();

    // Editable information tiles are not product cards and do not affect pagination.
    var infoNode = grid.querySelector('[data-los-scroll-info-config]');
    var infoTiles = [];
    try { if (infoNode) infoTiles = JSON.parse(infoNode.textContent); } catch (error) { infoTiles = []; }
    if (!Array.isArray(infoTiles)) infoTiles = [];
    // Preserve manually assigned positions. Rotate only automatically placed tiles.
    var autoTiles = infoTiles.filter(function(tile) { return tile && !tile.positionFixed; });
    if (autoTiles.length > 1) {
      var rotation = Math.floor(Math.random() * autoTiles.length);
      var slots = autoTiles.map(function(tile) { return tile.position; });
      autoTiles.forEach(function(tile, index) { tile.position = slots[(index + rotation) % slots.length]; });
    }
    // One accessible native dialog for all editorial cards, including infinite-scroll additions.
    var infoDialog = document.createElement('dialog');
    infoDialog.className = 'los-scroll-info-dialog';
    infoDialog.setAttribute('aria-label', 'Informationen und Wissenswertes');
    infoDialog.setAttribute('aria-modal', 'true');
    var dialogClose = document.createElement('button');
    dialogClose.type = 'button';
    dialogClose.className = 'los-scroll-info-dialog__close';
    dialogClose.textContent = '×';
    dialogClose.setAttribute('aria-label', 'Zurück zu den Produkten');
    var dialogContent = document.createElement('div');
    dialogContent.className = 'los-scroll-info-dialog__content';
    infoDialog.append(dialogClose, dialogContent);
    root.appendChild(infoDialog);
    var lastInfoTrigger = null;
    var infoByCard = new WeakMap();
    function safeInfoUrl(value) {
      if (!value) return null;
      try {
        var u = new URL(value, window.location.origin);
        return u.origin === window.location.origin && /^https?:$/.test(u.protocol) ? u.pathname + u.search + u.hash : null;
      } catch (error) { return null; }
    }
    function openInfo(info, trigger) {
      lastInfoTrigger = trigger;
      dialogContent.replaceChildren();
      if (info.eyebrow) {
        var kicker = document.createElement('small');
        kicker.textContent = info.eyebrow;
        dialogContent.appendChild(kicker);
      }
      var heading = document.createElement('h2');
      heading.id = 'los-scroll-info-heading-' + (root.id || 'collection');
      infoDialog.setAttribute('aria-labelledby', heading.id);
      heading.textContent = info.title;
      dialogContent.appendChild(heading);
      if (info.cardType !== 'newsletter' && info.image && /^(https:)?\/\//.test(info.image)) {
        var hero = document.createElement('img');
        hero.src = info.image;
        hero.alt = info.imageAlt || info.title || '';
        hero.loading = 'lazy';
        dialogContent.appendChild(hero);
      }
      if (info.detail || info.body) {
        var paragraphs = String(info.detail || info.body).split(/\n\s*\n/);
        paragraphs.forEach(function(part) {
          var text = part.trim();
          if (!text) return;
          var match = text.match(/^([1-9][0-9]*[.]|[^:]{2,48}:)[ ]+(.+)$/s);
          if (match) {
            var section = document.createElement('section');
            section.className = 'los-scroll-info-dialog__tip';
            var subhead = document.createElement('h3');
            subhead.textContent = match[1];
            var explanation = document.createElement('p');
            explanation.textContent = match[2];
            section.append(subhead, explanation);
            dialogContent.appendChild(section);
          } else {
            var p = document.createElement('p');
            p.textContent = text;
            dialogContent.appendChild(p);
          }
        });
      }
      var target = safeInfoUrl(info.url);
      if (target) {
        var link = document.createElement('a');
        link.href = target;
        link.textContent = info.label || 'Mehr erfahren';
        dialogContent.appendChild(link);
      }
      var back = document.createElement('button');
      back.type = 'button';
      back.className = 'los-scroll-info-dialog__back';
      back.textContent = '← Zurück zur Produktauswahl';
      back.addEventListener('click', function() { infoDialog.close(); });
      dialogContent.appendChild(back);
      infoDialog.dataset.tone = ['sage','sand','lavender','sky'].indexOf(info.tone) >= 0 ? info.tone : 'sage';
      infoDialog.showModal();
      infoDialog.scrollTop = 0;
      dialogClose.focus();
    }
    grid.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-los-scroll-info-open]');
      if (!trigger || !grid.contains(trigger)) return;
      var info = infoByCard.get(trigger.closest('[data-los-scroll-info-card]'));
      if (info && info.kind === 'promotion' && info.url) return;
      if (info && !infoDialog.open) openInfo(info, trigger);
    });
    dialogClose.addEventListener('click', function() { infoDialog.close(); });
    infoDialog.addEventListener('click', function(event) {
      if (event.target !== infoDialog) return;
      var rect = infoDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) {
        infoDialog.close();
      }
    });
    infoDialog.addEventListener('close', function() {
      dialogContent.replaceChildren();
      if (lastInfoTrigger && lastInfoTrigger.isConnected) lastInfoTrigger.focus({ preventScroll: true });
    });
    function renderInfoTiles() {
      grid.querySelectorAll('[data-los-scroll-info-card]').forEach(function(node) { node.remove(); });
      var products = Array.prototype.slice.call(grid.querySelectorAll('[data-lmp-product-card]'));
      var lastCardAtPosition = Object.create(null);
      infoTiles.forEach(function(info) {
        if (!info || !info.title || !products.length) return;
        var now = Date.now();
        if (info.visibleFrom && Date.parse(info.visibleFrom) > now) return;
        if (info.visibleUntil && Date.parse(info.visibleUntil) <= now) return;
        var position = Math.max(1, Math.floor(Number(info.position) || 8));
        if (position > products.length) return;
        var card = document.createElement('article');
        card.className = 'los-scroll-info-card' + (info.kind === 'promotion' ? ' los-scroll-info-card--promotion' : '') + (info.cardType === 'newsletter' ? ' los-scroll-info-card--newsletter' : '');
        card.setAttribute('data-los-scroll-info-card', '');
        card.dataset.tone = ['sage','sand','lavender','sky'].indexOf(info.tone) >= 0 ? info.tone : 'sage';
        infoByCard.set(card, info);
        var opener = document.createElement('button');
        opener.type = 'button';
        opener.className = 'los-scroll-info-card__open';
        opener.setAttribute('data-los-scroll-info-open', '');
        if (info.kind === 'promotion' && info.cardType === 'newsletter') {
          opener.setAttribute('data-los-newsletter-promo', '');
          opener.removeAttribute('data-los-scroll-info-open');
        }
        opener.setAttribute('aria-haspopup', 'dialog');
        opener.setAttribute('aria-label', info.title + ' öffnen');
        if (info.image && /^(https:)?\/\//.test(info.image)) {
          var image = document.createElement('img');
          image.src = info.image;
          image.alt = info.imageAlt || info.title || '';
          image.loading = 'lazy';
          opener.appendChild(image);
        }
        var content = document.createElement('div');
        content.className = 'los-scroll-info-card__content';
        if (info.eyebrow) { var eyebrow = document.createElement('small'); eyebrow.textContent = info.eyebrow; content.appendChild(eyebrow); }
        var title = document.createElement('h3'); title.textContent = info.title; content.appendChild(title);
        if (info.body) { var description = document.createElement('p'); description.textContent = info.body; content.appendChild(description); }
        var hint = document.createElement('span');
        hint.className = 'los-scroll-info-card__hint';
        hint.textContent = info.cardType === 'newsletter' ? 'Jetzt zum Newsletter anmelden ↗' : (info.kind === 'promotion' ? (info.label || 'Angebot ansehen') + ' ↗' : 'Wissen entdecken ↗');
        if (info.kind === 'promotion' && info.cardType !== 'newsletter' && info.url && /^(https:\/\/|\/[^\/])/.test(info.url)) {
          hint.textContent = info.label || 'Angebot ansehen';
          opener.addEventListener('click', function(event) { event.preventDefault(); window.location.assign(info.url); });
        }
        content.appendChild(hint);
        opener.appendChild(content);
        card.appendChild(opener);
        var anchor = lastCardAtPosition[position] || products[position - 1];
        anchor.insertAdjacentElement('afterend', card);
        lastCardAtPosition[position] = card;
      });
    }
    renderInfoTiles();

    if (!button) return;

    var loading = false;
    var finished = false;
    var autoLoadPaused = false;

    function setLoading(isLoading) {
      loading = isLoading;
      button.disabled = isLoading;
      button.textContent = isLoading ? 'Produkte werden geladen ...' : 'Weitere Produkte laden';
      if (panel) panel.classList.toggle('is-loading', isLoading);
    }

    // Skip empty source pages caused by supplier-specific tile filtering.
    // Bound each batch to avoid unbounded requests when many pages are empty.
    function loadNext() {
      var nextUrl = button.getAttribute('data-next-url');
      if (!nextUrl || loading || finished) return;
      setLoading(true);
      var visited = Object.create(null);
      var checked = 0;
      var maxPagesPerBatch = 8;

      function fetchPage(url) {
        if (!url || visited[url] || checked >= maxPagesPerBatch) {
          button.setAttribute('data-next-url', url || '');
          autoLoadPaused = true;
          setLoading(false);
          return Promise.resolve();
        }
        // Only request pages from this storefront, never external URLs.
        var target;
        try { target = new URL(url, window.location.href); }
        catch (error) { throw new Error('Invalid pagination URL'); }
        if (target.origin !== window.location.origin) throw new Error('External pagination URL blocked');
        var currentPreviewId = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (currentPreviewId) target.searchParams.set('preview_theme_id', currentPreviewId);
        visited[url] = true;
        checked += 1;
        return fetch(target.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nextGrid = doc.querySelector('[data-lmp-products-grid]');
            if (!nextGrid) throw new Error('Product grid missing');
            var cards = Array.prototype.slice.call(nextGrid.querySelectorAll('[data-lmp-product-card]'));
            var nextButton = doc.querySelector('[data-lmp-load-more]');
            var followingUrl = nextButton ? nextButton.getAttribute('data-next-url') : '';
            if (cards.length) {
              var emptyNotice = grid.querySelector('.lmp-empty');
              if (emptyNotice) emptyNotice.remove();
              cards.forEach(function (card) { grid.appendChild(document.importNode(card, true)); });
              renderPromos();
              renderInfoTiles();
              document.dispatchEvent(new CustomEvent('lmp:products:appended'));
            }
            if (followingUrl) button.setAttribute('data-next-url', followingUrl);
            if (!followingUrl) {
              finished = true;
              setLoading(false);
              if (panel) panel.innerHTML = '<p class="lmp-infinite-text lmp-infinite-text--done">Alle sichtbaren Produkte dieser Auswahl wurden geladen.</p>';
              return;
            }
            if (!cards.length && checked < maxPagesPerBatch && !visited[followingUrl]) {
              return fetchPage(followingUrl);
            }
            if (!cards.length && checked >= maxPagesPerBatch) autoLoadPaused = true;
            setLoading(false);
          });
      }

      fetchPage(nextUrl).catch(function () {
        autoLoadPaused = true;
        setLoading(false);
        button.textContent = 'Laden erneut versuchen';
      });
    }

    button.addEventListener('click', function () { autoLoadPaused = false; loadNext(); });

    // When the first Shopify page contains only suppressed vidaXL items,
    // continue to the next page without requiring a customer click.
    if (!grid.querySelector('[data-lmp-product-card]')) loadNext();

    if ('IntersectionObserver' in window && sentinel) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !autoLoadPaused) loadNext();
        });
      }, { rootMargin: '520px 0px 520px 0px' });
      observer.observe(sentinel);
    }
  }

  function initializeCollectionTiles(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-lmp-infinite-root]')) initInfinite(scope);
    scope.querySelectorAll('[data-lmp-infinite-root]').forEach(initInfinite);
  }

  ready(function () {
    initializeCollectionTiles(document);
    // Shopify replaces sections in the editor without a full page refresh.
    document.addEventListener('shopify:section:load', function(event) {
      initializeCollectionTiles(event.target);
    });
    document.addEventListener('shopify:section:unload', function(event) {
      event.target.querySelectorAll('.los-scroll-info-dialog').forEach(function(dialog) {
        if (dialog.open) dialog.close();
      });
    });
  });
})();
